import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HOME_CONTENT_MOCK } from '../../data/home-content.mock';
import type { HomeValorContent } from '../../models/home-valor-content.model';
import { HomeValorService } from '../../services/home-valor.service';
import { prepareValorIntroHtml, prepareValorTitleHtml } from '../../utils/home-valor-html.util';

@Component({
  selector: 'app-home-valor',
  templateUrl: './home-valor.component.html',
  styleUrls: ['./home-valor.component.scss'],
  standalone: false,
})
export class HomeValorComponent implements OnInit {
  content: HomeValorContent = buildInitialContent();

  titleSafe: SafeHtml = '';
  introSafe: SafeHtml = '';

  constructor(
    private readonly homeValorService: HomeValorService,
    private readonly sanitizer: DomSanitizer
  ) {
    this.applyContent(this.content);
  }

  ngOnInit(): void {
    this.homeValorService.loadContent().subscribe((content) => {
      this.applyContent(content);
    });
  }

  private applyContent(content: HomeValorContent): void {
    this.content = content;
    this.titleSafe = this.sanitizer.bypassSecurityTrustHtml(content.titleHtml); // NOSONAR — sanitize en mapper
    this.introSafe = this.sanitizer.bypassSecurityTrustHtml(content.introHtml); // NOSONAR — sanitize en mapper
  }
}

function buildInitialContent(): HomeValorContent {
  const mock = HOME_CONTENT_MOCK.valor;
  return {
    eyebrow: mock.eyebrow,
    titleHtml: prepareValorTitleHtml(mock.titleHtml),
    introHtml: prepareValorIntroHtml(mock.introHtml),
    beneficios: mock.beneficios.map((benefit) => ({ ...benefit })),
  };
}
